import script from "./Draggable.vue?vue&type=script&lang=js"
export * from "./Draggable.vue?vue&type=script&lang=js"

import "./Draggable.vue?vue&type=style&index=0&id=155407b9&lang=scss"

export default script